export default {
    SET_LANGUAGE_CURRENT: (state, payload) => {
        state.language_current = payload;
    },
    SET_CHECKED: (state, payload) => {
        state.checked = payload;
    },
    SET_USER: (state, payload) => {
        state.user = payload;
    },
    SET_newOrder: (state, payload) => {
        state.newOrder = payload;
    },
    OPEN_MODAL: (state, payload) => {
        state.modalName = payload;
    },
    SET_VALUE: (state, payload) => {
        state.valueSelected = payload;
    },
    SET_COURSE: (state, payload) => {
        state.courses = payload;
    },
    SET_TEXT: (state, payload) => {
        state.text = payload;
    },
    SET_LAST_UPDATE: (state, payload) => {
        state.lastUpdate = payload;
    },
    SET_ROLES: (state, payload) => {
        state.roles = payload;
    },
    SET_LANGUAGES: (state, payload) => {
        state.languages = payload;
    },
    SET_MESSAGE(state, payload) {
        state.message = payload;
      },
    SET_BUSINESS: (state, payload) => {
        state.business = payload;
    },
    SET_LANGUAGE: (state, payload) => {
        state.language = payload;
    },
    SET_LOCATION: (state, payload) => {
        state.location = payload;
    },
    SET_ROLE: (state, payload) => {
        state.roles = payload;
    },
    SET_STATS: (state, payload) => {
        state.stats = payload;
    },
    SET_ROUTES: (state, payload) => {
       // console.log(payload);
        state.routes = payload;
    },
    SET_SCHEDULE: (state, payload) => {
        state.schedules = payload;
    },
    SET_ROOT: (state, payload) => {
        state.root = payload;
    },
    SET_HOST: (state, payload) => {
        state.host = payload;
    },
    SET_SEC_API_URL: (state, payload) => {
        state.secApiUrl = payload;
    },
    UPDATE_LIST: (state, payload) => {
       // console.log(payload);
        state.list = payload;
    }
}